import React, { useEffect, useState, useRef } from 'react';
import { Form, Modal, Spinner, ButtonGroup, InputGroup, ToggleButton } from 'react-bootstrap';
import { Button, Card, CardBody, Row, Col, Label, Input } from 'reactstrap';
import Axios from 'axios';
import { useHistory } from 'react-router-dom';
import { Backspace, Images, Save2Fill, Trash, Upload } from 'react-bootstrap-icons';
import { Typeahead } from 'react-bootstrap-typeahead';
import 'react-bootstrap-typeahead/css/Typeahead.css';
import * as Yup from 'yup';
import { Formik } from 'formik';

import common from '../../../commonData';
import dateformat from 'dateformat';
import Table from 'views/tableaddedit';
import readXlsxFile from 'read-excel-file';
import FormTable from './gridtableForm';

var count = 0;

function ReglementForm({ setShowAdd, show, setIsSave, setDatas, setMsg, setMsgravity, setActualise, actualise, EditreglementData }) {
    var ladate = new Date();
    const [codeart, setCodeart] = useState([]);
    const [facturenonsolde, setFacturenonsolde] = useState([]);
    const [fournisseur, setFournData] = useState([]);
    const [canal_payement, setListeCanal] = useState([]);
    const [listeSelect, setListeSelect] = useState(EditreglementData.listeSelect || []);
    const [load, setLoad] = useState(false);
    const [totalMontantImpute, setTotalImpute] = useState(0);
    const [type, setType] = useState(EditreglementData.type_reglement || 'Espèce');
    const history = useHistory();
    const fourn = useRef(null);
    const [states, setState] = useState({
        date_regl:
            dateformat(EditreglementData.date_regl, 'yyyy-mm-dd') ||
            dateformat(ladate.getMonth() + 1 + '/' + ladate.getDate() + '/' + ladate.getFullYear(), 'yyyy-mm-dd'),
        montant: EditreglementData.montant || 0,
        fournisseur_id: EditreglementData.fournisseur_id,
        norecu: EditreglementData.norecu || '',
        nocheq: EditreglementData.nocheq || '',
        canale_payement: EditreglementData.canale_payement || '1'
        // type_reglement: EditreglementData.type_reglement || 'Espèce'
    });
    const { date_regl, montant, fournisseur_id, nocheq, norecu, canale_payement } = states;
    // console.log(common.societe);
    useEffect(() => {
        if (!localStorage.getItem('user-info')) {
            history.push('/login');
        }
        (async function anyNameFunction() {
            setLoad(true);
            const facturenonsolde = Axios.get(common.ipapi + '/api/entre-facture/facturenonsolde/' + common.societe);
            const getFourn = Axios.get(common.ipapi + '/api/fournisseur/all');
            const canal = Axios.get(common.ipapi + '/api/canal-paiement');
            await Axios.all([facturenonsolde, getFourn, canal])
                .then(
                    Axios.spread((...responses) => {
                        setFacturenonsolde(responses[0].data.datas);
                        if (EditreglementData.listeSelect && EditreglementData.listeSelect.length > 0) {
                            //setListeSelect(EditreglementData.listeSelect);
                        } else {
                            setListeSelect(responses[0].data.datas);
                        }
                        setFournData(responses[1].data);
                        setListeCanal(responses[2].data.datas);
                        setLoad(false);
                    })
                )
                .catch((errors) => {
                    setLoad(false);
                });
        })();
    }, []);

    function saveReglement(values, setSubmitting) {
        try {
            if (facturenonsolde.length == 0) {
                setMsg('Veuillez sélectionner les produits');
                setMsgravity('danger');
                setIsSave(true);
                return;
            }
            if (values.montant <= 0) {
                setMsg('Le montant doit être supérieur à 0');
            }
            if (values.fournisseur_id == 0) {
                setMsg('Veuillez sélectionner un fournisseur');
                setMsgravity('danger');
                setIsSave(true);
                return;
            }
            if (values.montant < totalMontantImpute) {
                setMsg('Le montant du règlement est inférieur au total imputé');
                setMsgravity('danger');
                setIsSave(true);
                return;
            }

            setLoad(true);
            setSubmitting(true);
            const filteredProduct = listeSelect.filter((product, index) => {
                return product.montant_impute && parseInt(product.montant_impute) > 0;
            });
            var formData = new FormData();
            formData.append('date_regl', values.date_regl);
            formData.append('montant', values.montant);
            formData.append('fournisseur_id', values.fournisseur_id);
            formData.append('listeSelect', JSON.stringify(filteredProduct));
            formData.append('type_reglement', type);
            formData.append('nocheq', values.nocheq);
            formData.append('norecu', values.norecu);
            formData.append('user_id', common.userid);
            formData.append('societe', common.societe);
            formData.append('canale_payement', values.canale_payement);
            Axios({
                url: EditreglementData?.id
                    ? common.ipapi + '/api/reglementfrs/update/' + EditreglementData?.id
                    : common.ipapi + '/api/reglementfrs/store',
                method: 'POST',
                headers: {
                    'Content-Type': 'form-data'
                },
                data: formData
            })
                .then((res) => {
                    if (res.status !== 200) {
                        setMsg('Veuillez vérifier votre connexion internet');
                        setMsgravity('info');
                        setIsSave(false);
                        setLoad(false);
                        setSubmitting(false);
                        return;
                    }
                    if (res.data.status === 1) {
                        setCodeart([]);
                        fourn.current.clear();
                        setMsg(res.data.msg);
                        setIsSave(true);
                        setMsgravity('info');
                        setFacturenonsolde([]);
                        count++;
                        setActualise(!actualise);
                        setLoad(false);
                        setSubmitting(false);
                        setTimeout(handleClose, 600);
                    } else {
                        if (res.data.msg == 23000) {
                            setMsg('Veuillez remplir tous les champs');
                        } else {
                            setMsg(res.data.msg);
                        }
                        setMsgravity('danger');
                        setIsSave(true);
                        setLoad(false);
                        setSubmitting(false);
                    }
                })
                .catch((error) => {
                    setMsg('Une erreur à eu lieu lors de la création');
                    setIsSave(false);
                    setMsgravity('danger');
                    setLoad(false);
                    setSubmitting(false);
                });
        } catch (error) {
            setMsg('Veuillez vérifier votre connexion internet');
            setIsSave(true);
            setMsgravity('danger');
            setLoad(false);
            setSubmitting(false);
        }
    }

    const handleClose = () => {
        count = 0;
        setShowAdd(false);
        setIsSave(false);
    };

    return (
        <>
            <Modal show={load} size="sm" aria-labelledby="contained-modal-title-vcenter" centered>
                <Modal.Body>
                    Veuillez patienter.......
                    <Spinner animation="grow" variant="warning" />
                </Modal.Body>
            </Modal>

            <Formik
                initialValues={{
                    montant: montant,
                    date_regl:
                        date_regl || dateformat(ladate.getMonth() + 1 + '/' + ladate.getDate() + '/' + ladate.getFullYear(), 'yyyy-mm-dd'),
                    fournisseur_id: fournisseur_id,
                    norecu: norecu,
                    nocheq: nocheq,
                    canale_payement: canale_payement,
                    user_id: common.userid
                }}
                // enableReinitialize
                validationSchema={Yup.object().shape({
                    fournisseur_id: Yup.number().required(common.msg),
                    date_regl: Yup.date().required(common.msg)
                })}
                onSubmit={async (values, { setSubmitting }) => {
                    try {
                        saveReglement(values, setSubmitting);
                    } catch (err) {
                        setMsg('Une erreur à eu lieu');
                        setMsgravity('danger');
                        setIsSave(true);
                        setLoad(false);
                    }
                }}
            >
                {({ handleBlur, handleChange, handleSubmit, isSubmitting, values, setFieldValue, setFieldTouched }) => (
                    <Modal show={show} fullscreen={true} onHide={handleClose}>
                        <Form noValidate onSubmit={handleSubmit}>
                            <Modal.Header>
                                {EditreglementData?.id ? 'MODIFICATION REGLEMENT FOURNISSEUR' : 'FAIRE UN REGLEMENT FOURNISSEUR'}
                                <Backspace onClick={handleClose} color="red" size={30} />
                            </Modal.Header>
                            <Modal.Body>
                                <div id="lightbody">
                                    <Row>
                                        <Col md={3}>
                                            <Form.Group as={Row} className="mb-3">
                                                <Form.Label column sm={3}>
                                                    Fournisseur:
                                                </Form.Label>
                                                <Col sm={9}>
                                                    <Typeahead
                                                        id="fournisseur_id"
                                                        ref={fourn}
                                                        multiple={false}
                                                        onChange={(selected) => {
                                                            const value = selected.length > 0 ? selected[0].id : 0;
                                                            setFieldValue('fournisseur_id', value);
                                                            setListeSelect(facturenonsolde.filter((fact) => fact.fournisseur_id === value));
                                                        }}
                                                        onInputChange={(text, event) => setFieldValue('fournisseur_id', text)}
                                                        onBlur={(e) => setFieldTouched('fournisseur_id', true)}
                                                        labelKey="nomfourn"
                                                        options={fournisseur}
                                                        selected={fournisseur.slice(
                                                            fournisseur.findIndex((element) => element.id === values.fournisseur_id),
                                                            fournisseur.findIndex((element) => element.id === values.fournisseur_id) + 1
                                                        )}
                                                    />
                                                </Col>
                                            </Form.Group>
                                            <Form.Group as={Row} className="mb-3">
                                                <Form.Label column sm={3}>
                                                    Date règlement:
                                                </Form.Label>
                                                <Col sm={9}>
                                                    <Form.Control
                                                        id="date_regl"
                                                        type="date"
                                                        placeholder="Date règlement"
                                                        aria-describedby="inputGroupPrepend"
                                                        required
                                                        size="sm"
                                                        value={values.date_regl}
                                                        onBlur={handleBlur}
                                                        onChange={handleChange}
                                                    />
                                                </Col>
                                            </Form.Group>
                                            <Form.Group as={Row} className="mb-3">
                                                <Form.Label column sm={3}>
                                                    Montant règlement:
                                                </Form.Label>
                                                <Col sm={9}>
                                                    <Form.Control
                                                        id="montant"
                                                        type="number"
                                                        placeholder="Montant règlement"
                                                        aria-describedby="inputGroupPrepend"
                                                        required
                                                        size="sm"
                                                        value={values.montant}
                                                        onBlur={handleBlur}
                                                        onChange={handleChange}
                                                    />
                                                </Col>
                                            </Form.Group>
                                            <Form.Group as={Row} className="mb-3">
                                                <Form.Label column sm={4}>
                                                    N° de reçu
                                                </Form.Label>
                                                <Col sm={8}>
                                                    <Form.Control
                                                        type="text"
                                                        placeholder="N° de reçu"
                                                        aria-describedby="inputGroupPrepend"
                                                        size="sm"
                                                        id="norecu"
                                                        value={values.norecu}
                                                        onBlur={handleBlur}
                                                        onChange={handleChange}
                                                    />
                                                    <Form.Control.Feedback type="invalid">
                                                        Veuillez saisir le code article
                                                    </Form.Control.Feedback>
                                                </Col>
                                            </Form.Group>
                                            <Form.Group as={Row} className="mb-3">
                                                <Form.Label column sm={4}>
                                                    Canal de paiement:
                                                    {/* <Star color="red" size={10} /> */}
                                                </Form.Label>
                                                <Col sm={8}>
                                                    <Input
                                                        id="canale_payement"
                                                        type="select"
                                                        aria-label="Canal de paiement"
                                                        value={values.canale_payement}
                                                        onBlur={handleBlur}
                                                        onChange={handleChange}
                                                        size="small"
                                                    >
                                                        {canal_payement.map((d, index) => {
                                                            return (
                                                                <option key={index} value={d.id}>
                                                                    {d.lib_canal}
                                                                </option>
                                                            );
                                                        })}
                                                        {/* {[
                                                            { id: 1, lib: 'Banque Bridge' },
                                                            { id: 2, lib: 'Caisse Primaire' },
                                                            { id: 3, lib: 'Caisse Sécondaire' },
                                                            { id: 4, lib: 'MTN Money' },
                                                            { id: 5, lib: 'Orange Money' },
                                                            { id: 6, lib: 'Wave' }
                                                        ].map((d, index) => {
                                                            return (
                                                                <option key={index} value={d.id}>
                                                                    {d.lib}
                                                                </option>
                                                            );
                                                        })} */}
                                                    </Input>
                                                </Col>
                                            </Form.Group>

                                            <Form.Group as={Col} md="12" controlId="revision">
                                                <InputGroup hasValidation>
                                                    <ButtonGroup>
                                                        {[
                                                            { name: 'Espèce', value: 'Espèce' },
                                                            { name: 'Chèque', value: 'Chèque' },
                                                            { name: 'Virement', value: 'Virement' }
                                                        ].map((radio, idx) => (
                                                            <ToggleButton
                                                                key={idx}
                                                                id={`radiorevision-${idx}`}
                                                                type="radio"
                                                                size="sm"
                                                                variant={idx % 2 ? 'outline-warning' : 'outline-warning'}
                                                                value={radio.value}
                                                                checked={type === radio.value}
                                                                onChange={(e) => setType(e.currentTarget.value)}
                                                            >
                                                                {radio.name}
                                                            </ToggleButton>
                                                        ))}
                                                    </ButtonGroup>
                                                    <Form.Control.Feedback type="invalid">
                                                        Veuillez selectionnez la revision.
                                                    </Form.Control.Feedback>
                                                </InputGroup>
                                            </Form.Group>

                                            <Form.Group as={Row} className="mb-3">
                                                <Form.Label column sm={4}>
                                                    N° chèque/virement
                                                </Form.Label>
                                                <Col sm={8}>
                                                    <Form.Control
                                                        type="text"
                                                        placeholder="N° chèque/virement"
                                                        aria-describedby="inputGroupPrepend"
                                                        size="sm"
                                                        id="nocheq"
                                                        value={values.nocheq}
                                                        onBlur={handleBlur}
                                                        onChange={handleChange}
                                                    />
                                                    <Form.Control.Feedback type="invalid">
                                                        Veuillez saisir le code article
                                                    </Form.Control.Feedback>
                                                </Col>
                                            </Form.Group>
                                        </Col>
                                        <Col md={9}>
                                            <Card>
                                                <CardBody>
                                                    <Row>
                                                        <Col md={12}>
                                                            <FormTable
                                                                data={listeSelect}
                                                                setListeSelect={setListeSelect}
                                                                setTotalImpute={setTotalImpute}
                                                                totalMontantImpute={totalMontantImpute}
                                                                idreglement={EditreglementData?.id}
                                                            />
                                                        </Col>
                                                    </Row>
                                                </CardBody>
                                            </Card>
                                        </Col>
                                    </Row>
                                </div>
                            </Modal.Body>
                            <Modal.Footer>
                                <div className="ml-auto">
                                    <ButtonGroup size="sm">
                                        <Button color="danger" onClick={handleClose}>
                                            <Backspace color="#000" size={20} />
                                        </Button>
                                        <Button type="submit" variant="ligth" disabled={isSubmitting}>
                                            {isSubmitting ? (
                                                <Spinner animation="border" variant="success" />
                                            ) : (
                                                <Save2Fill color="#807f7e" size={20} />
                                            )}{' '}
                                            Enregister
                                        </Button>
                                    </ButtonGroup>
                                </div>
                            </Modal.Footer>
                        </Form>
                    </Modal>
                )}
            </Formik>
        </>
    );
}

export default ReglementForm;
